import api from './index';

export default {
  // Obtener detalles de un pedido
  async getPedidoDetails(id: number) {
    try {
      const response = await api.get(`/pedido/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener detalles del pedido:', error);
      throw error;
    }
  },
};